import { motion } from "framer-motion";
import { BRAND_VIDEOS } from "@/data/siteData";

export const VideoShowcase = () => (
  <section id="films" className="relative py-28 lg:py-36 bg-[#0E1730]" data-testid="videos-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-2xl"
      >
        <p className="text-teal-300 tracking-[0.3em] text-xs uppercase mb-4">DX films</p>
        <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight">
          Feel the journey <span className="italic text-teal-300">before you pack.</span>
        </h2>
      </motion.div>

      <div className="mt-14 grid gap-6 lg:grid-cols-3">
        {BRAND_VIDEOS.map((v, i) => (
          <motion.figure
            key={v.title}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
            className={`group relative rounded-2xl overflow-hidden border border-white/10 ${i === 0 ? "lg:col-span-2 lg:row-span-1" : ""}`}
            data-testid={`brand-video-${i}`}
          >
            <video
              className="w-full h-64 lg:h-80 object-cover"
              src={v.url}
              poster={v.poster}
              controls
              muted
              loop
              playsInline
              preload="none"
            />
            <figcaption className="absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-[#0B132B]/90 to-transparent pointer-events-none">
              <p className="font-serif text-lg">{v.title}</p>
              <p className="text-xs text-teal-300 tracking-widest uppercase mt-1">{v.subtitle}</p>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);

export default VideoShowcase;
